module.exports = __webpack_public_path__ + "static/media/DWZ_03.9a4c9b2f.jpg";